import { Size } from '@busybusy/webapp-react-ui';
import { useMemo } from 'react';
import ColorArray, { IColorArrayProps } from '../ColorArray/ColorArray';

export interface IColorPickerProps extends Omit<IColorArrayProps, 'selectedColors'> {
  colors: string[];
  colorSize: Size;
  selectedColor?: string | null;
  error?: boolean;
  onChange?: (color: string) => void;
  className?: string | object;
}

const ColorPicker = (props: IColorPickerProps) => {
  const { selectedColor, onChange, ...rest } = props;

  const color = useMemo(() => (selectedColor ? [selectedColor] : null), [selectedColor]);

  return <ColorArray onClick={onChange} selectedColors={color} {...rest} />;
};

ColorPicker.defaultProps = {
  ...ColorArray.defaultProps,
};

export default ColorPicker;
